import { Model, Attr, BelongsTo, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Rendition extends ApplicationRecord {
  static jsonapiType = 'renditions';

  @Attr() resolution: string;
  @Attr() media: string;
  @Attr() image: string;
}
